import { workflowNodeType } from './types';

export const SKELETON_NODE_ID = 'skeleton-node';

export const FOLDER_NODE_ID = {
  [workflowNodeType.inputAttribute]: 'folder-input-attributes',
} as const;
